import FuseSuspense from '@fuse/core/FuseSuspense';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';

// local imports
import AppContext from 'app/AppContext';
import { PageTitle } from 'app/components/atoms';

const useStyles = makeStyles(theme => ({
  root: {}
}));

function LayoutFull(props) {
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
  const appContext = useContext(AppContext);
  const { routes } = appContext;
  const classes = useStyles({ ...props, config });

  return (
    <>
      <div id="fuse-layout" className={clsx(classes.root, config.mode, 'w-full flex')}>
        <div className="flex flex-col flex-auto min-w-0">
          <main id="fuse-main" className="flex flex-col flex-auto min-h-screen min-w-0 relative">
            <div className="flex flex-col flex-auto min-h-0 relative z-10">
              <FuseSuspense>{renderRoutes(routes)}</FuseSuspense>

              {props.children}
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default memo(LayoutFull);
